import styles from './TermsPage.module.css'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import { Helmet } from 'react-helmet'
import cn from 'classnames';

export default function TermsPage() {
  return (
    <>
      <Helmet>
        <title>Условия использования | Восток Строй</title>
        <meta name="description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="keywords" content="недвижимость, девелопер, Каспийск, новостройки, квартиры" />
        <meta name="author" content="Восток Строй" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vostokstroy.com/terms" />

        <meta property="og:title" content="Условия использования | Восток Строй" />
        <meta property="og:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta property="og:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" />
        <meta property="og:url" content="https://vostokstroy.com/terms" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Восток Строй" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Условия использования | Восток Строй" />
        <meta name="twitter:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="twitter:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" />

        <link rel="icon" type="image/svg+xml" href="/favicons/main-fav-32x32.svg" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/main-fav-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/main-fav-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/main-apple-touch-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="180x180" href="/favicons/main-fav-180x180.png" />
      </Helmet>
      <Header theme='light'></Header>
      <div className={styles.content}>
          <div className={styles.page_title}>
            <h2>Пользовательское соглашение</h2>
          </div>
          <div className={cn('text-2_font', styles.page_text)}>
            <p>
              Наши юристы уже пишут текст для этой страницы ✍️
            </p>
          </div>
      </div>
      <Footer theme='light'></Footer>
    </>
  )
}
